<template>
  <div class="container map" :style="styles1">
    <div class="wraps">
      <div class="center">
        <div class="tops">
            <div class="map-container" :style="styles">
              <t-map v-if="mapCode=='TX'&&show"  ref="map"  :data="resData" :loading.sync="loading"></t-map>
              <t-map1  v-if="mapCode=='GD'&&show" ref="map"  :data="resData" :loading.sync="loading"></t-map1>
            </div>
        </div>
      </div>
      <div class="copy" v-if="!nocopy">由快递鸟提供技术支持</div>
    </div>
  </div>
</template>

<script>
import tMap from '@/components/map.vue'
import tMap1 from '@/components/map1.vue'
export default {
  props: {},
  components: {
    tMap,
    tMap1
  },
  data() {
    return {
      checked: true,
      show: false,
      loading: false,
      DataSign: "",
      AppKey: process.env.VUE_APP_APPKEY,
      params: {},
      time: 1000 * 60 * 30,
      timer: null,
      form: {
        RequestData: {
          Code:""
        },
        DataSign: "",
        EBusinessID: process.env.VUE_APP_EBUSINESSID,
        RequestType: "8006",
        DataType: "2",
      },
      tableData: [],
      resData: {},
      flag: false,
      nocopy:null,
      styles:{},
      styles1:{},
      query:this.$route.query,
      mapCode:null
    };
  },
  created() {
    
  },
  mounted() {
    this.getParams();
    this.setCss();
  },
  computed: {
    
  },
  watch: {
    loading(val) {
      // if (!val) {
      //   document.body.style.overflow = "auto";
      // } else {
      //   document.body.style.overflow = "hidden";
      // }
    },
  },
  methods: {
    getParams() {
      let Code = this.$route.query.code;
      this.nocopy = this.$route.query.nocopy;
      if(!Code){
        this.flag = true;
      }
      this.form.RequestData = {
        Code
      };
      this.getSign();
    },
    setCss(){
      let width = this.$route.query.width;
      let height=this.$route.query.height;
      let wCss={}
      if(height){
        if(height.indexOf("px")<0&&height.indexOf("vh")<0){
          if(Number(height)){
            height = Number(height)+"px"
          }
        }
      }
      this.styles={
        height
      }
      if(width){
        if(width.indexOf("px")<0){
          if(Number(width)){
            width = Number(width)+"px"
          }
        }
        wCss={
          width,
          maxWidth:'100%',
          padding:0
        }
      }
      this.styles1={
        ...wCss
      }
    },
    getSign() {
      let data = this.$md5(
        JSON.stringify(this.form.RequestData) + this.AppKey
      );
      let res = this.$base64.btoa(data);
      this.form.DataSign = res;
      setTimeout(()=>{
        this.getData()
      },500)
    },
    getData() {
      let data = Object.assign({}, this.form);
      this.loading = true;
      // document.body.style.overflow = "hidden";
      data.RequestData = JSON.stringify(data.RequestData);
      data = this.$qs.stringify(data);
      this.$http(this.$api.exterfaceInvoke, data)
        .then((res) => {
          this.show = true;
          if (res && res.data && res.data.Success) {
            let data = res.data;
            this.resData = data;
            this.mapCode = data.mapCode;
            this.tableData = data.Traces || [];
            this.tableData = this.tableData.reverse();
            this.tableData.forEach(ele=>{
                ele.AcceptTime = this.$tool.formatDate(ele.AcceptTime)
            })
          } else {
            this.mapCode="GD"
            this.loading = false;
            this.show = false;
            this.$message(res.data.Reason)
          }
        })
        .catch(() => {
          this.loading = false;
          this.show = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and (max-width:750px) {
  .center{
    padding-top:0;
  }
}
</style>
